import { render, staticRenderFns } from "./editSubcuenta.vue?vue&type=template&id=1a8f79b7&scoped=true"
import script from "./editSubcuenta.vue?vue&type=script&lang=js"
export * from "./editSubcuenta.vue?vue&type=script&lang=js"
import style0 from "./editSubcuenta.vue?vue&type=style&index=0&id=1a8f79b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8f79b7",
  null
  
)

export default component.exports